import React from "react";
import { Modal, Tooltip } from "antd";
import moment from "moment";
import Icons from "components/icons";
import { Localize } from "components/service";
import StaffScanLocationMap from "./staff-scan-location-map";
import StaffScanLocationGuidance from "./staff-scan-location-guidance";
import { getStaffCurrentCheckInZone } from "../helpers/staff-scan-location-helper";
import { getStaffAuditAccuracyQuality } from "../helpers/staff-audit-log-presentation-helper";


const formatScanDateTime = (value) => (
    value && moment(value).isValid() ? moment(value).format("DD.MM.YYYY, HH:mm:ss") : "—"
);

const formatCoordinate = (value) => (
    value !== null && value !== undefined && value !== "" && Number.isFinite(Number(value)) ?
        Number(value).toFixed(6) :
        "—"
);

const StaffScanLocationModal = ({ event, open, location, onClose }) => {
    const { scan, zone } = location || {};
    const currentZone = getStaffCurrentCheckInZone(event);
    const usesCurrentZone = !zone && Boolean(currentZone);
    const displayedZone = zone || currentZone;
    const accuracyQuality = getStaffAuditAccuracyQuality(scan?.accuracy);
    const workerName = `${ scan?.worker?.name || "" } ${ scan?.worker?.surname || "" }`.trim();
    const hasDistance = (
        scan?.distance_from_zone !== null &&
        scan?.distance_from_zone !== undefined &&
        Number.isFinite(Number(scan.distance_from_zone))
    );
    const titleKey = scan?.result === "outside_zone" ?
        "STAFF_MANAGEMENT.ScanModal_Title_OutsideZone" :
        "STAFF_MANAGEMENT.ScanModal_Title";
    const modalTitle = (
        <strong className="modal-title">
            <Localize>{ titleKey }</Localize>
        </strong>
    );

    return (
        <Modal
            className="modal-standard staff-scan-location-modal"
            centered
            visible={ Boolean(open && scan) }
            title={ modalTitle }
            footer={ null }
            width={ 460 }
            destroyOnClose={ true }
            onCancel={ onClose }>
            { scan &&
                <>
                    <div className="d-flex staff-scan-location-modal__meta-row">
                        <div className="d-flex flex-column staff-scan-location-modal__meta">
                            <span>
                                <Localize>STAFF_MANAGEMENT.ScanModal_Worker</Localize>:{ " " }
                                <strong className="staff-scan-location-modal__value">
                                    { workerName || "—" }
                                </strong>
                            </span>
                            <span>
                                <Localize>STAFF_MANAGEMENT.ScanModal_DateTime</Localize>:{ " " }
                                <strong className="staff-scan-location-modal__value">
                                    { formatScanDateTime(scan.created_at) }
                                </strong>
                            </span>
                            { hasDistance &&
                                <span>
                                    <Localize>STAFF_MANAGEMENT.ScanModal_Distance</Localize>:{ " " }
                                    <strong className="staff-scan-location-modal__value">
                                        { scan.distance_from_zone } m
                                    </strong>
                                </span>
                            }
                            <span>
                                <Localize>STAFF_MANAGEMENT.Column_GpsAccuracy</Localize>:{ " " }
                                <strong className="staff-scan-location-modal__value">
                                    <span className={ `staff-audit-accuracy--${ accuracyQuality }` }>
                                        <Localize>{ `STAFF_MANAGEMENT.AuditAccuracy_${ accuracyQuality }` }</Localize>
                                        { accuracyQuality !== "unknown" && ` (${ Number(scan.accuracy.toFixed(1)) } m)` }
                                    </span>
                                </strong>
                                { open && <StaffScanLocationGuidance scan={ scan } zone={ zone } /> }
                            </span>
                            <span>
                                <Localize>STAFF_MANAGEMENT.ScanModal_Location</Localize>:{ " " }
                                <strong className="staff-scan-location-modal__value">
                                    { formatCoordinate(scan.latitude) }, { formatCoordinate(scan.longitude) }
                                </strong>
                            </span>
                        </div>
                        { usesCurrentZone &&
                            <Tooltip
                                overlayClassName="staff-attendance-warning-tooltip"
                                placement="right"
                                trigger={ [ "click" ] }
                                title={ <Localize>STAFF_MANAGEMENT.ScanModal_CurrentZoneWarning</Localize> }>
                                <button
                                    type="button"
                                    className="d-flex align-items-center justify-content-center staff-scan-location-modal__zone-info">
                                    <Icons.StaffInfo aria-hidden="true" />
                                    <span className="visually-hidden">
                                        <Localize>STAFF_MANAGEMENT.ScanModal_CurrentZoneWarning</Localize>
                                    </span>
                                </button>
                            </Tooltip>
                        }
                    </div>

                    <StaffScanLocationMap scan={ scan } zone={ displayedZone } />
                </>
            }
        </Modal>
    );
};

export default StaffScanLocationModal;
